export const INPUT_NODE_FORM = 'form'
export const INPUT_NODE_INPUT = 'input'
export const INPUT_NODE_OPTION = 'option'
export const INPUT_NODE_SELECT = 'select'
export const INPUT_NODE_TEXTAREA = 'textarea'

export const INPUT_NODE_TYPES = [
  INPUT_NODE_FORM,
  INPUT_NODE_INPUT,
  INPUT_NODE_OPTION,
  INPUT_NODE_SELECT,
  INPUT_NODE_TEXTAREA
]

export const INPUT_TYPE_TEXT = 'text'
export const INPUT_TYPE_EMAIL = 'email'
export const INPUT_TYPE_PHONE = 'tel'

export const TEXT_ME = 'text me'

export const WIDGET_FORM_MODALS = 'widget-form-modals'

// constants related to error response
export const FIELD = 'fieldName'
export const MESSAGE = 'message'

// constants related to the set of form data spec returned in the mvh response
export const FORM_DATA_SPEC = 'LeadFormSpec'

// constants related to the form data spec
export const CONTACT = 'contact'
export const EXTENSION_CATEGORY = 'extensionCategory'
export const FIELD_NAME = 'name'
export const FIELDS = 'fields'
export const REQUIRED = 'required'
export const IF_SPECIFIED = 'if-specified'
export const EMAIL_OR_PHONE = 'email-or-phone'
export const FORM_FIELD_ACCEPT_TERMS = 'acceptTerms'
export const FORM_FIELD_CONTACT_METHOD = 'preferredMethodOfContact'
export const FORM_FIELD_EMAIL = 'email'
export const FORM_FIELD_FIRST_NAME = 'firstName'
export const FORM_FIELD_LAST_NAME = 'lastName'
export const FORM_FIELD_MESSAGE = 'message'
export const FORM_FIELD_PHONE = 'phone'
export const FORM_FIELD_TERMS_CONDITIONS = 'termsAndConditions'
export const FORM_FIELD_ZIP_CODE = 'postalcode'
export const VALUES = 'values'
